export default "__VITE_ASSET__rPhdecqsXn$1yBUS8of3NQ__"